import axios from 'axios';
import api from '@api';

const jwtAxios = axios.create({
  baseURL: api.baseUri, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    // jwtAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    localStorage.setItem('token', token);
    axios.interceptors.request.use(function (config) {
      // const token = store.getState().session.token;
      config.headers.vtt_user_signature = token;
      return config;
    });
  } else {
    delete jwtAxios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
    localStorage.removeItem('myData');
    localStorage.removeItem('tripid');
  }
};

export default jwtAxios;
